module.exports = __webpack_public_path__ + "static/img/noTop@2x.19969924.png";